"use strict";
exports.__esModule = true;
var execRegex_1 = require("../regex/execRegex");
exports["default"] = (function (val) {
    return execRegex_1["default"](val, 'email');
});
